import CommonApp from '../../app.js';

CommonApp.module.directive('nsScrolly', function() {
    return {
        restrict: 'A',
        link: function(scope, element, attrs, $document) {
            // var raw = element[0];
            var $window = angular.element(window);
            $window.bind('scroll', function() {
                // var scrollPos = document.body.scrollTop + document.documentElement.clientHeight;
                var top = (document.documentElement && document.documentElement.scrollTop) ||
                document.body.scrollTop;
                var scrollPos = top + document.documentElement.clientHeight;
                var elemBottom = element[0].offsetTop + element.height();
                if (scrollPos >= elemBottom) {
                    scope.$apply(attrs.nsScrolly);
                }
            });
        }
    };
});



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/angular/directives/scrolly/scrolly.js
// module id = 256
// module chunks = 0